import React, { useState } from "react";
import { ImCross } from "react-icons/im";

const OverlayContact = ({
  img,
  name,
  links,
  isOverlayTrue,
  setIsOverLayTrue,
}) => {
  return (
    <section
      className={`${
        isOverlayTrue
          ? "overlay-github-contact show-overlay-github-contact"
          : "overlay-github-contact"
      }`}
    >
      <img src={img} alt={name} className="overlay-top-p-image" />
      <button onClick={() => setIsOverLayTrue(false)} className="btn-cross">
        <ImCross />
      </button>
      <div className="a-link-absolute">
        {links.map((single, indexOfIndex) => {
          const { icon, git } = single;
          return (
            <a
              onClick={() => setIsOverLayTrue(false)}
              key={indexOfIndex}
              href={git}
              target="_blank"
              rel="noreferrer"
              className="a-link opps-a-link"
            >
              {icon}
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default OverlayContact;
